import React from 'react'
import { Button } from '@mui/material'
import { Col, Row } from "react-bootstrap"
import './DidNotConsent.scss'

export default function DidNotConsent(){
    return (
        <div className="container">
            <div className="no-consent-section">
                <Row>
                    <Col lg={12}>
                        <h5>You Have Chosen Not To Do Business Electronically</h5>
                        <p>You have chosen not to do business electronically. We are here to assist in any manner you choose, so please contact us for other options in obtaining your insurance coverage.</p>

                        <div className="button-section">
                            <Button variant="outlined" color="primary" className="btn-wide-sm" href="/quote/whole-life/securian-secure-promise/consent">Previous</Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}
